<template>
  <b-input-group>
    <b-form-input type="text" v-model="joinTeamUrl" disabled />
    <div class="input-group-append">
      <b-button variant="default" type="button"
        v-clipboard:copy="joinTeamUrl"
        v-clipboard:success="onCopy"
        v-clipboard:error="onCopyError">
        <span v-html="copyButton">Copied!</span>
      </b-button>
    </div>
  </b-input-group>
</template>

<script>
import {mapGetters} from 'vuex';
import {adminLinkShare} from "@/lib/track/events";

export default {
  data() {
    return {
      copied: false
    };
  },
  computed: {
    ...mapGetters(['joinTeamUrl']),
    copyButton() {
      return this.copied ? 'Copied!' : '<i class="fas fa-clone"></i> Copy';
    }
  },
  methods: {
    onCopy() {
      // show message??
      this.copied = true;
      adminLinkShare('copy');
    },
    onCopyError() {
      // show message??
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/shared/TeamShareInput.vue